module.exports = __webpack_public_path__ + "img/1-3.fe2fe062.svg";